import styled from 'styled-components';

import {flexColumn} from '~/shared/theme/FlexLayout';
import {headingXXL} from '~/shared/theme/typography';

import {Subtitle} from './styled';

const Root = styled.div`
  ${flexColumn}
  align-items: center;
  gap: 4px;
`;

/* The symbol sits to the left of the digits at a smaller size, so it is its own element. `ltr` keeps
   that order fixed regardless of the app's direction. */
const AmountRow = styled.div`
  display: flex;
  align-items: flex-end;
  direction: ltr;
  color: ${({theme}) => theme.colors.contentDefault};
`;

const Currency = styled.span`
  font-size: 32px;
  line-height: 40px;
  font-weight: 900;
`;

const Amount = styled.span`
  ${headingXXL}
`;

type AmountHeadlineProps = {
  amount: number;
  subtitle: string;
  /* The success screen leads with the subtitle and reports the amount underneath it. */
  subtitleAbove?: boolean;
  'data-test-id'?: string;
};

/* Labels the dialog with the amount and what happens to it, e.g. "₪10.50 יועברו לקרדיט שלך". Used by
   both the confirmation and the success screens, which differ in the subtitle's tense and in which
   of the two lines the design leads with. */
const AmountHeadline = ({
  amount,
  subtitle,
  subtitleAbove,
  'data-test-id': dataTestId,
}: AmountHeadlineProps) => {
  const subtitleLine = <Subtitle>{subtitle}</Subtitle>;
  const amountLine = (
    <AmountRow data-test-id={dataTestId}>
      <Currency>₪</Currency>
      <Amount>{amount.toFixed(2)}</Amount>
    </AmountRow>
  );

  /* Ordered in the markup rather than by `column-reverse`, so the dialog is read out in the order it
     is laid out in. */
  return (
    <Root id="modal-title">
      {subtitleAbove ? (
        <>
          {subtitleLine}
          {amountLine}
        </>
      ) : (
        <>
          {amountLine}
          {subtitleLine}
        </>
      )}
    </Root>
  );
};

export default AmountHeadline;
